/**
 * Normalizes anomaly footprint geometry to WKT for the legacy OpenLayers map (mfs-old-map).
 */

import {PolygonConverterUtil} from '@app/utils/polygon-converter.util';

/** Returns WKT POLYGON string, or null if geometry cannot be parsed. */
export function normalizePolygonAsWkt(polygonRaw: unknown): string | null {
  const str = typeof polygonRaw === 'string' ? polygonRaw.trim() : '';
  if (!str) {
    return null;
  }
  if (/^(POLYGON|MULTIPOLYGON)\s*/i.test(str)) {
    return str;
  }
  const coords = PolygonConverterUtil.polygonJsonToCoordinates(str);
  if (!coords.length) {
    return null;
  }
  return PolygonConverterUtil.latLngArrayToWKT(coords);
}
